import React, { Fragment, useEffect, useState } from 'react';
import MasterComponentWraper from '../../Backend/MasterComponentWraper';
import { useParams } from 'react-router-dom';
import FormValidator from '../../../inc/FormValidator';
import NavigationHeder from '../../Navigations/NavigationHeder';
import LinkBtn from '../../inc/LinkBtn';
import Button from '../../inc/Button';
import SimpleLoading from '../../Loading/SimpleLoading';
import Collapse from '../../inc/Collapse';
import FieldsRenderer from '../../Purchase Orders Internal/Edit PO/FieldsRenderer';
import { areObjectsDifferent, getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import Api from '../../../inc/Api';
import Settings from '../../../inc/Settings';
import Helper from '../../../inc/Helper';
import CommonAPICalls from '../Common Integration Calls/CommonApiCalls';

let defaultExternalSystemApiFormsObject = null;
const ExternalSystemApiFormsDetailView = () => {
  const [externalSystemApiFormsData, setExternalSystemApiFormsData] = useState({});
  const [appMaster, setAppMaster] = useState([]);

  const [loading, setLoading] = useState(true); 

  const { id } = useParams();

  let getByIdApiCall = false; 

  useEffect(() => { 
    getExternalSystemApiFormsById();
    fetchDataForAppMaster();
  }, [])

  let validator;

  const validationConfigure = () => {
    let fieldConfig = [
      { name: "api_name", displayName: "Api name", types: ["Required"] },
      { name: "api_endpoint", displayName: "Api endpoint", types: ["Required"] },
      { name: "auth_method", displayName: "Auth method", types: ["Required"] },
      { name: "additional_info", displayName: "Additional info", types: ["Required"] },
      { name: "app", displayName: "Sequence", types: ["Required"] },
      { name: "sequence", displayName: "Credentials", types: ["Required"] }
    ];

    if(!validator) {
      validator = new FormValidator(fieldConfig)
    }
  }

  validationConfigure();

  const fetchDataForAppMaster = async () => {
    const apiCalls = new CommonAPICalls();
    try {
      const systemAppMasterResponse = await apiCalls.getSystemAppMaster();
      if (systemAppMasterResponse) {
        setAppMaster(systemAppMasterResponse);
      };
    } catch (error) { 
      setAppMaster([]); 
    }
  }

  const getExternalSystemApiFormsById = () => { 
    if(getByIdApiCall) return;

    getByIdApiCall = true;
    setLoading(true);

    let api = Api;
    api.setUserToken()
    api.axios().get(Settings.apiAppUrl+`/external-api/${id}/`,{}).then(function(res){
      if(res?.status === 200){ 
        setExternalSystemApiFormsData(res?.data);
        defaultExternalSystemApiFormsObject = res?.data;
        setLoading(false);
      } else {
        Helper.alert(res?.data?.message, 'error')
      }
    }).catch((res) => { 
      getPopupMessageBasedOnStatus(res) 
      setLoading(false)
    })
  }

  const ExternalSystemApiForms = () => { 
    let textBoxInputSettings = [
      {
        className: "col-lg-4",
        label: "Api name",
        inputType: "text",
        required: true,
        id: "api_name",
        name: "api_name",
      },
      {
        className: "col-lg-4",
        label: "Api endpoint",
        inputType: "text",
        required: true,
        id: "api_endpoint",
        name: "api_endpoint",
      },
      {
        className: "col-lg-4",
        label: "Auth method",
        inputType: "text",
        required: true,
        id: "auth_method",
        name: "auth_method",
      },
      {
        className: "col-lg-4",
        label: "Additional info",
        inputType: "text",
        required: true,
        id: "additional_info",
        name: "additional_info",
      },
      {
        className: "col-lg-4",
        label: "App",
        inputType: "dropdown",
        options: appMaster,
        required: true,
        id: "app",
        name: "app",
      },
      {
        className: "col-lg-4",
        label: "Sequence",
        inputType: "number",
        required: true,
        id: "sequence",
        name: "sequence",
      }
    ];

    return (
      <Collapse open={true} title={"General"}>
        <div className='row mb-3'>
          <FieldsRenderer fieldsArray={textBoxInputSettings} updateState={setExternalSystemApiFormsData} currentState={externalSystemApiFormsData} />
        </div>
      </Collapse>
    )
  }

  const SaveHandler = () => {
    if(!areObjectsDifferent(defaultExternalSystemApiFormsObject, externalSystemApiFormsData)) return;
    
    let validData = {
      ...externalSystemApiFormsData
    };

    if(!validator.isValid(validData)){
      validator.displayMessage();
      validator.reset() 
      return;
    };

    let api = Api;
    api.setUserToken();

    api.axios().put(Settings.apiAppUrl+`/external-api/${id}/`, externalSystemApiFormsData).then(function(res){
      if(res?.status === 200){
        Helper.alert(res?.data?.message || 'External system api updated successfully', 'success');
        getExternalSystemApiFormsById();
      } else {
        Helper.alert(res?.data?.message, 'error')
      }
    }).catch((res) => {  
      getPopupMessageBasedOnStatus(res);
    })  
  }

  return (
    <div className='container-fluid'>
      <NavigationHeder title={ `<span style="color:#000;"> Edit External System Api #</span> ${externalSystemApiFormsData.api_name}` }>
        <LinkBtn to={-1} isActive= {false} title={"Close"} />
        <Button isActive= {true} onClick ={SaveHandler} title={"Save"} icon={'/images/icons/save-white.svg'} />
      </NavigationHeder>

      {loading ? <SimpleLoading /> : (
        <Fragment>
          {ExternalSystemApiForms()} 
        </Fragment>
      )} 
    </div>
  )
}

export default (MasterComponentWraper(ExternalSystemApiFormsDetailView));